<template>
    <div style="padding: 0px; overflow-y: auto; height: 100%; width: 100%; position: absolute; overflow-x: hidden;">
        <div :style="{
            display: 'flex',
            width: '100%',
            height: is_mobile?'100%': undefined,
        }">
            <div
                v-if="show_folders && !is_mobile"
                style="position: fixed; padding: 0px; width: 22%; height: 100%"
            >
                <div style="background-color: var(--v-primaryLighter-base);padding: 0px 15px; border-radius: 10px 10px 0 0; display: flex; align-items: center; height:10%">
                    <button style="color: var(--v-primaryDark-base); font-family: Roboto; font-weight: 500; font-size: 16px; letter-spacing: 0px;"
                        @click="moveToFolder(true)"
                    >
                        {{$t("ViesValidator.my_unit")}}
                    </button>
                    <div style="display: flex; margin-left: auto;">
                        <button
                            v-if="userHasPermissions()"
                            :style="{
                                padding: '5px',
                                backgroundColor: 'var(--v-neutral-base)',
                                marginRight: '5px',
                                borderRadius: '10px',
                                opacity: selected_folder && selected_folder!='Mi unidad' ? 1 : 0.4,
                            }"
                            @click="component.showPopUpEditFolder(screen_data.companyFolders, selected_folder)" :disabled="!selected_folder || selected_folder == 'Mi unidad'"
                        >
                            <v-icon color="var(--v-primary-base)" size="18">mdi-pencil</v-icon>
                        </button>
                        <button
                            v-if="userHasPermissions()"
                            :style="{
                                paddingTop: '5px',
                                paddingBottom: '0px',
                                paddingLeft: '7px',
                                paddingRight: '7px',
                                backgroundColor: 'var(--v-neutral-base)',
                                marginRight: '5px',
                                borderRadius: '10px',
                                opacity: selected_folder && selected_folder!='Mi unidad' ? 1 : 0.4,
                            }"
                            @click="component.showPopUpDeleteFolder()" :disabled="!selected_folder || selected_folder == 'Mi unidad'"
                        >
                            <AppIcon :src="require('@/assets/delete_purple.svg')" :size="29" style="height: 16.88px; width: 15px;" />
                        </button>
                        <button
                            v-if="userHasPermissions()"
                            style="border: 1px solid var(--v-primary-base); padding: 5px 9px; display: flex; align-items: center; border-radius: 10px;"
                            @click="component.showPopUpCreateFolder(selected_folder)"
                        >
                            <AppIcon :src="require('@/assets/add.svg')" :size="29" style="height: 10px; width: 10px;" />
                            <span style="padding-left: 5px; font-family: Roboto; font-weight: 500; font-size: 13px; letter-spacing: 0px; color:var(--v-primary-base);">{{ $t("ViesValidator.new") }}</span>
                        </button>
                    </div>
                </div>
                <div style="width:100%; overflow-y:auto; background-color: #ffffff; height: calc(90% - 83px); border-radius: 0 0 10px 10px;">
                    <FolderSelectorComponent
                        v-if="screen_data && screen_data.companyFolders && screen_data.companyFolders.length"
                        :items="screen_data.companyFolders[0].children"
                        v-model="selected_folder"
                        :show_selected_route="false"
                        @input="moveToFolder()"
                        initial_selected_folder=""
                        ref="folder_selector_ref"
                    />
                </div>
            </div>
            <div :style="{
                marginLeft: show_folders && !is_mobile? '24.4%': '0',
                // paddingLeft: show_folders ? '0.8vw' : null,
                paddingRight: '0px',
                paddingTop: '0px',
                marginBottom: is_mobile? undefined:'10px',
                width: show_folders ? '75%' : '100%',
                filter: show_folder_menu_mobile ? 'brightness(20%)' : null,
                height: is_mobile? '100%': undefined
            }">
                <div :style="{
                    width: '100%',
                    borderRadius: is_mobile?'10px 10px 0 0':'10px',
                    backgroundColor: '#ffffff',
                    height: is_mobile? '100%': undefined
                }">
                    <div :style="{
                        display: 'flex',
                        alignItems: 'center',
                        padding: is_mobile? '1vh 4vw':'1.5vh 2vw',
                        height: is_mobile? '7%': undefined
                    }">
                        <div :style="{
                            color: 'var(--v-primaryDark-base)',
                            fontWeight: '600',
                            fontSize: '20px',
                            textAlign: 'left',
                        }">
                            {{$t("ViesValidator.documents")}}
                        </div>
                        <v-btn
                            @click="$router.push({
                                name: 'generic-document-loader', 
                                params: { companydb_id: companydb_id },
                                query: {
                                    selected_folder: selected_folder,
                                    name_folder_selected: getNameFolderSelected(screen_data.currentFolderRoute)
                                }
                            });"	
                            color="var(--v-primary-base)"
                            outlined
                            :icon="is_mobile"
                            class="text-none"
                            :style="{
                                borderRadius: '10px',
                                padding: is_mobile? '0px':'10px',
                                marginLeft: '2vw'
                            }"
                        >
                            <div style="display: flex; align-items: center; justify-content: center;">
                                <AppIcon :src="require('@/assets/upload_file.svg')" :size="29" style="{
                                        height: is_mobile?'20px':'20px',
                                        width: is_mobile?'18px':'20px',
                                    }" />
                                <span v-if="!is_mobile" style="font-weight: 500; font-size: 13px; font-family: Roboto; letter-spacing: 0px">
                                    {{$t("ViesValidator.upload_documents")}}
                                </span>
                            </div>
                        </v-btn>

                        <div style="display:flex; align-items:center; margin-left:auto">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn @click="refreshDocuments()" color="primary" icon v-bind="attrs" v-on="on" :loading="screen_data.loading_odocs">
                                        <v-icon>mdi-refresh</v-icon>
                                    </v-btn>
                                </template>
                                <span>{{$t("ViesValidator.refresh")}}</span>
                            </v-tooltip>
                            
                            <v-menu v-if="!is_mobile" 
                                offset-y
                                v-model="screen_data.action_menu"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn 
                                        :disabled="!(screen_data.selectedItems.length > 0)"
                                        v-bind="attrs" 
                                        v-on="on"
                                        class="action__btn"
                                    >
                                        <JobProgress v-model="screen_data.asyncJobState" v-on:done="jobDone()" :job_id="screen_data.asyncJobId" class="progress-circular">
                                            <template v-slot:progress>
                                                <v-progress-circular
                                                    v-if="screen_data.asyncJobState==='running'"
                                                    indeterminate           
                                                    color="primary"
                                                ></v-progress-circular>
                                            </template>
                                            <template v-slot:done>
                                                {{$t("ViesValidator.actions")}}
                                                <v-icon v-if="screen_data.action_menu">mdi-menu-up</v-icon>
                                                <v-icon v-else>mdi-menu-down</v-icon>
                                            </template>
                                        </JobProgress>
                                    </v-btn>
                                </template>
                                <v-list  >
                                    <v-list-item
                                        link
                                        @click="deleteOtherDocument"
                                    >
                                        <v-list-item-title>{{$t("ViesValidator.delete_documents")}}</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        link
                                        @click="downloadDocuments"
                                    >
                                        <v-list-item-title>{{$t("ViesValidator.download_documets")}}</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        link
                                        @click="screen_data.dialogChangeWorkflow=true"
                                    >
                                        <v-list-item-title>{{$t("ViesValidator.change_workflow")}}</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        v-if="userHasPermissions()"
                                        link
                                        @click="moveDocumentsToFolder()"
                                    >
                                        <v-list-item-title>{{$t("ViesValidator.move_to_a_folder")}}</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>   
                        </div>
                    </div>
                    <v-divider />

                    <div 
                        :style="{
                            display: 'flex',
                            padding: is_mobile? '1vh 4vw':'1.5vh 2vw',
                            alignItems: 'center',
                            height: is_mobile? '7%': undefined
                        }"
                    >
                        <div ref="dropdown" class="dropdown tooltip-wrapper" style="position: relative;">
                            <button 
                                style="padding: 8px; padding-top: 10px; padding-bottom: 4px; background-color: #e7e7e7; border-radius: 10px; margin: 0px" @click="handleManageFolder()"
                                @mouseover="isHovering = true"
                                @mouseleave="isHovering = false"
                            >
                                <AppIcon :src="isHovering? require('@/assets/folder_managed_hover.svg'): require('@/assets/folder_managed.svg')" :size="29" style="height: 16.7px; width: 19.38px;" />
                            </button>
                            <div v-if="show_folder_menu" class="dropdown-menu" style="position: absolute; top: 120%; left: 0px; background-color: #FFFFFF; width: 17vw; border-radius: 8px; box-shadow: 0px 4px 20px 0px #E7E7E7;z-index: 1000; padding: 0px 0px;">
                                <div 
                                    v-if="userHasPermissions()"
                                    @click="change_folder_option('create_folder')"
                                    class="dropdown-item"
                                    style="padding: 10px 24px"
                                >
                                    <AppIcon :src="require('@/assets/create_new_folder.svg')" :size="29" style="height: 15px; width: 19px;" />
                                    <span style="padding-left: 8px; font-family: Roboto; font-weight: 400; font-size: 14px; letter-spacing: 0px; color: #3D3D3D;">
                                        {{ $t('ViesValidator.create_folder') }}
                                    </span>
                                </div>
                                <div 
                                    v-if="show_folders == false"
                                    @click="change_folder_option('show_folders')" 
                                    class="dropdown-item" style="padding: 10px 24px; display: flex; align-items: center;"
                                >
                                    <AppIcon :src="require('@/assets/chrome_reader_mode.svg')" :size="29" style="height: 15px; width: 19px;" />
                                    <span style="padding-left: 8px; font-family: Roboto; font-weight: 400; font-size: 14px; letter-spacing: 0px; color: #3D3D3D;">
                                        Vista Mi unidad
                                    </span>
                                </div>
                                <div 
                                    v-else
                                    @click="change_folder_option('not_show_folders')" 
                                    class="dropdown-item" style="padding: 10px 24px; display: flex; align-items: center;"
                                >
                                    <AppIcon :src="require('@/assets/chrome_reader_mode.svg')" :size="29" style="height: 15px; width: 19px;" />
                                    <span style="padding-left: 8px; font-family: Roboto; font-weight: 400; font-size: 14px; letter-spacing: 0px; color: #3D3D3D;">
                                        Ocultar Mi unidad
                                    </span>
                                </div>
                            </div>
                            <span v-if="show_folder_menu == false" class="tooltip-text">{{capitalizeText($t('ViesValidator.actions').toLowerCase())}}</span>
                        </div>

                        <div :style="{
                            border: '1px solid #aaaaaa', 
                            borderRadius: '10px', 
                            marginLeft: '15px', 
                            display: 'flex', 
                            alignItems: 'center',
                            padding: '1vh 2vw',
                            width: is_mobile?'78vw':'20vw',
                        }">
                            <span v-if="screen_data && screen_data.currentFolderRoute" style="font-family: Roboto; font-weight: 400; font-size: 13px; letter-spacing: 0px; color: #565656">
                                {{round_folder_paths(screen_data.currentFolderRoute)}}
                            </span>
                        </div>
                        <app-search-bar
                            v-if="!is_mobile"
                            class="mx-0 my-0"
                            :filters="screen_data.availableFilters"
                            @updateObject="updateFilter"
                            @resetAllFilters="removeAllFilt"
                            style="padding: 0px;"
                        />
                    </div>
                    <div 
                        v-if="is_mobile"
                        :style="{
                            display: 'flex',
                            padding: '1vh 4vw',
                            paddingTop: '0vh',
                            alignItems: 'center',
                            width: '100%',
                            height: is_mobile? '6%': undefined
                        }"
                    >
                        <!-- <div style="padding: 5px 10px;background-color: #d9d9d9; border-radius:30px; display:flex; align-items: center; width: 30%">
                            <span style="color: #1d1d1e; font-family: Roboto; font-weight: 400; font-size: 13px;">Añadir filtro</span>
                            <AppIcon :src="require('@/assets/add_gray.svg')" :size="29" style="height: 13px; width: 13px; padding-left: 5px;" />
                        </div> -->
                        <div style="width: 32%;">
                            <AddFilterDocuments @add-filter-clicked="handlerActivateFilter"/>
                        </div>
                        <div style="padding: 5px 10px;background-color: #d9d9d9; border-radius:30px; display:flex; align-items: center; width: 48%; margin-left: 5%">
                            <span style="color: #1d1d1e; font-family: Roboto; font-weight: 400; font-size: 13px;">
                                {{$t("ViesValidator.filters")}}({{countFilters()}})
                            </span>
                        </div>
                        <button style="padding: 5px 8px;background-color: #d9d9d9; border-radius:30px; display:flex; align-items: center; width: 10%; margin-left: 5%" @click="clear_filters">
                            <AppIcon :src="require('@/assets/delete_gray.svg')" :size="29" style="height: 20px; width: 18px; padding-left: 5px;" />
                        </button>
                    </div>
                    <v-divider/>


                    <v-card-text class="px-0 pt-0 card-title-footer-color" v-if="!is_mobile">
                        <span v-if="screen_data.showSelect && !screen_data.hideHeaderCheckbox">
                            <v-checkbox
                                v-if="showSelectAll()"
                                class="ma-0 pt-5 pl-4"
                                v-model="screen_data.selectAllItems"
                                :disabled="screen_data.loadingItems"
                                @change="changeSelectAllItems"
                            >
                            <template v-slot:label>
                                <span class="text-field-size">Aplicar en los {{screen_data.totalItems}} elementos</span>
                            </template>
                            </v-checkbox>
                        </span>
                        <v-data-table
                        v-model="screen_data.selectedItems"
                        :items="screen_data.other_documents"
                        :headers="filteredHeaders"
                        :show-select="screen_data.showSelect"
                        :loading="screen_data.loading_odocs"
                        :server-items-length="screen_data.totalItems"
                        :page.sync="screen_data.currentPage"
                        :items-per-page="screen_data.limit" 
                        :footer-props="{
                                        'items-per-page-text': $t('ViesValidator.docs_per_page'),
                                        'items-per-page-options': screen_data.footerItemsPerPageOptions,
                                        }"
                        :no-data-text="screen_data.textNoResults"
                        :loading-text="screen_data.textLoading"
                        class="pt-5 px-5"
                        @update:items-per-page="changeLimit"
                        @update:page="changeOffset"
                        @update:sort-by="sortTable"
                        @update:sort-desc="sortTableDesc"
                        @toggle-select-all=""
                        :height="data_table_height"
                        fixed-header
                        :item-key="screen_data.itemKey"
                        :mobile="is_mobile"
                        @click:row="selectRow"
                        >
                            <!-- Columnas Personalizables -->
                            <template v-for="header in filteredHeaders" v-slot:[`item.${header.value}`]="{ item }">
                                <span class="font-color">
                                    <slot :name="header.value" v-bind="item" v-if="header.value=='type'">{{changeLanguage(item[header.value])=="edit"?item[header.value]: $t("ViesValidator."+changeLanguage(item[header.value]))}}</slot>
                                    <slot :name="header.value" v-bind="item" v-else-if="header.value=='state'">{{$t('ViesValidator.'+item[header.value])}}</slot>
                                    <slot :name="header.value" v-bind="item" v-else-if="header.value == 'created'">{{ map_document_date(item[header.value]) }}</slot>
                                    <slot :name="header.value" v-bind="item" v-else-if="header.value == 'id' && item['uuid']">
                                        <div style="display: flex; align-items: center; max-width: 120px;">
                                            <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; flex: 1; font-size: 12px;">{{ item['uuid'] }}</span>
                                            <v-btn @click.stop="copyIdToClipboard(item['uuid'])" icon x-small style="margin-left: 4px;">
                                                <v-icon x-small style="opacity: 0.6;">mdi-content-copy</v-icon>
                                            </v-btn>
                                        </div>
                                    </slot>
                                    <slot :name="header.value" v-bind="item" v-else-if="header.value == 'id'">
                                        <div style="display: flex; align-items: center; max-width: 120px;">
                                            <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; flex: 1; font-size: 12px;">{{ item[header.value] }}</span>
                                            <v-btn @click.stop="copyIdToClipboard(item[header.value])" icon x-small style="margin-left: 4px;">
                                                <v-icon x-small style="opacity: 0.6;">mdi-content-copy</v-icon>
                                            </v-btn>
                                        </div>
                                    </slot>
                                    <slot :name="header.value" v-bind="item" v-else-if="header.value == 'workflow_name'">{{ changeLanguage(item[header.value])=='edit'?(item[header.value]): $t('ViesValidator.'+changeLanguage(item[header.value]))}}</slot>
                                    <slot :name="header.value" v-bind="item" v-else>{{ item[header.value] }}</slot>
                                </span>

                            </template>
                            <template v-if="screen_data.hideHeaderCheckbox" #header.data-table-select></template>
                                <!-- Header Personalizables -->
                            <template v-for="header in filteredHeaders" v-model="filteredHeaders.value" v-slot:[`header.${header.value}`]="{ header }">
                                <span tabindex="0">
                                    {{ changeLanguage(header.text)=="edit"? header.text:$t("ViesValidator."+changeLanguage(header.text)) }}
                                </span>
                            </template>
                            <!--Footer: Paginación-->
                            <template v-slot:[`footer.page-text`]="items">
                                {{ items.pageStart }} - {{ items.pageStop }} {{ $t("ViesValidator.of") }} {{ items.itemsLength }}
                            </template>
                        </v-data-table>
                    </v-card-text>

                    <!-- vista de filtros para mobiles -->
                    <div v-else style="height: auto; min-height: 80%; background-color: #ffffff;">
                        <div v-if="is_activate_filter" style="padding-bottom: 100px">
                            <div v-for="(item, index) in items_filter" :key="item.id">
                                <ItemFilterDocuments 
                                    :name="item.name" :imgSrc="item.imgSrc" :widthImg="item.widthImg" :heightImg="item.heightImg"
                                    :name_in_filter="name_in_filter" :orders_in_filter="orders_in_filter" :types_in_filter="types_in_filter" :date_from_in_filter="date_from_in_filter" :date_to_in_filter="date_to_in_filter" :pending_approval_in_filter="pending_approval_in_filter"
                                    @change-name-in-filter="changeNameInFilter" @change-types-in-filter="changeTypesInFilter" @change-date-from="changeDateFrom" @change-date-to="changeDateTo" @change-pending-approval-in-filter="changePendingApprovalInFilter"
                                />
                            </div>
                        </div>
                        <!-- vista de docs para mobiles -->
                        <div v-else>
                            <div v-for="(doc, index) in screen_data.other_documents" :key="doc.uuid">
                                <div style="padding: 1.2vh 5vw" @click="show_folder_menu_mobile?null:selectRow(doc)">
                                    <div style="margin-bottom: 0.5vh">
                                        <span style="font-family: Roboto; font-weight: 400; font-size: 14px; color: #565656">{{doc.original_file_name}}</span>
                                    </div>
                                    <div style="margin-bottom: 0.2vh">
                                        <span style="font-family: Roboto; font-weight: 600; font-size: 18px; color: #56565b">{{ $t("ViesValidator.type_of_document") }}: {{changeLanguage(doc.type)=='edit'?doc.type:$t("ViesValidator."+changeLanguage(doc.type))}}</span>
                                    </div>
                                    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1vh">
                                        <span style="font-family: Roboto; font-weight: 500; font-size: 14px; color: #888888">Workflow: {{changeLanguage(doc.workflow_name)=='edit'? doc.workflow_name : $t('ViesValidator.'+changeLanguage(doc.workflow_name))}}</span>
                                        <div style="padding: 1px 5px; border-radius: 10px; background-color: #aaaaaa; display: flex; align-items:center;justify-content: center; width: 20vw">
                                            <span style="font-family: Roboto; font-weight: 500; font-size: 12px; color: #ffffff;">{{abbreviate($t("ViesValidator."+doc.state))}}</span>
                                        </div>
                                    </div>
                                    <div style="display: flex; align-items: center;">
                                        <button @click.stop="handleShowInfo(doc.uuid)">
                                            <AppIcon :src="isInfoActive(doc.uuid)? require('@/assets/info_full_gray.svg'): require('@/assets/info_gray.svg')" :size="29" style="height: 19px; width: 19px;" />
                                        </button>
                                        <div style="margin-left: 7vw;">
                                            <button v-if="doc.id!=loading_download_mobile" @click.stop="downloadDocuments(doc)">
                                                <AppIcon :src="require('@/assets/download_for_offline_gray.svg')" :size="29" style="height: 19px; width: 19px;" />
                                            </button>
                                            <v-progress-circular
                                                v-else
                                                indeterminate
                                                size="17"
                                                width="2"
                                                color="primary"
                                                style="margin-bottom: 7px;"
                                            />
                                        </div>
                                    </div>
                                    <transition name="animation-information">
                                        <div v-if="isInfoActive(doc.uuid)">
                                            <div>
                                                <span style="font-family: Roboto; font-weight: 400; font-size: 12px; color: #56565b;">ID: {{doc.uuid}}</span>
                                            </div>
                                            <div>
                                                <span style="font-family: Roboto; font-weight: 400; font-size: 12px; color: #56565b;">{{ $t("ViesValidator.date") }}: {{fortmatedDate(doc.created)}}</span>
                                            </div>
                                        </div>
                                    </transition>
                                </div>
                                <v-divider />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <GenericWarningPopUp v-model="screen_data.errorPopUp"
            title="Error"
            :description="$t(screen_data.errorPopUpDescription)"
        />
        <v-dialog persistent max-width="600"
            v-model="screen_data.showDeletePupup"
        >
            <v-card>
                <v-card-text  class="text-center">
                    <v-icon size="55"
                    class="mt-4"
                    color="primary">mdi-alert-outline</v-icon>
                </v-card-text>
                <v-card-text class="text-center" style="font-size: 16px;">
                    {{$t("ViesValidator.warning_delete")}}<b>{{$t("ViesValidator.warning_delete_2")}}</b>
                </v-card-text>
                <v-checkbox
                    class="ma-0 pt-5 pl-4"
                    v-model="screen_data.cascadeEntities"
                    :label="$t('ViesValidator.checkbox_text')">
                    </v-checkbox>
                <v-card-actions class="action_btns">
                    <v-spacer></v-spacer>
                    <v-btn 
                        outlined
                        @click="confirmDeleteDocument(false)"
                        class="action_btn"
                        >
                        {{$t("ViesValidator.cancel")}}
                    </v-btn>
                    <v-btn 
                        color="primary_blue"
                        class="white--text action_btn"
                        :loading="screen_data.loading_d_other_doc"
                        @click="confirmDeleteDocument(true)"
                        >
                        {{$t("ViesValidator.delete")}}
                    </v-btn>
                </v-card-actions>
            </v-card>

        </v-dialog>

        <v-dialog persistent max-width="600"
            v-model="screen_data.popUpSelectFolder"
        >
            <v-card>
                <v-card-title class="text-center" >
                    {{ $t("ViesValidator.select_folder") }}
                </v-card-title>

                <v-card-text>
                    <FolderSelectorComponent
                        :items="screen_data.companyFolders"
                        v-model="selected_folder"
                        :show_selected_route="false"
                    />
                </v-card-text>
                <v-card-actions class="action_btns">
                    <v-spacer></v-spacer>
                    <v-btn 
                        outlined
                        @click="component.cancelFolderPopUp()"
                        class="action_btn"
                        >
                        {{$t("ViesValidator.cancel")}}
                    </v-btn>
                    <v-btn 
                        color="primary_blue"
                        class="white--text action_btn"
                        :disabled="selected_folder == null"
                        :loading="screen_data.loading_d_other_doc"
                        @click="acceptToMoveDocumentsToFolder()"
                        >
                        {{$t("ViesValidator.accept")}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="screen_data.dialogChangeWorkflow" persistent max-width="500">
            <v-card>
                <v-card-title class="card__headline">
                    <span>{{$t("ViesValidator.modify_workflow")}}</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-select
                        v-model="screen_data.selectedWorkflow"
                        :items="screen_data.workflowOptions"
                        item-text="name"
                        item-value="id"
                        outlined
                        dense
                        hide-details
                        class="my-4"
                    >
                    </v-select>
                </v-card-text>
                <v-card-actions class="action_btns">
                    <v-spacer></v-spacer>
                    <v-btn 
                        outlined
                        @click="screen_data.dialogChangeWorkflow=false"
                        class="action_btn"
                        >
                        {{$t("ViesValidator.cancel")}}
                    </v-btn>
                    <v-btn 
                        color="primary_blue"
                        class="white--text action_btn"
                        :disabled="screen_data.selectedWorkflow == undefined"
                        @click="changeWorkflow()"
                        >
                        {{$t("ViesValidator.change")}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent max-width="700" v-model="screen_data.popUpDeleteFolder" v-if="screen_data.popUpDeleteFolder" style="z-index: 2" ref="popup_delete_ref">
            <v-card>
                <v-card-title class="text-center">
                <b>{{ $t('ViesValidator.delete_folder') }}</b>
                </v-card-title>
                <v-card-text class="text-center">
                <div class="text-h6 mb-8">
                    {{$t("ViesValidator.warning_delete_folder")}}
                </div>
                <v-radio-group v-model="screen_data.deleteOption" class="text-left" column>
                    <v-radio
                    :label="$t('ViesValidator.delete_folder_only')"
                    value="delete_folder_keep_content"
                    ></v-radio>
                    <v-radio
                    :label="$t('ViesValidator.delete_folder_recursively')"
                    value="delete_folder_delete_content"
                    ></v-radio>
                </v-radio-group>
                </v-card-text>
                <v-card-actions class="action_btns">
                <v-spacer></v-spacer>
                <v-btn
                    outlined
                    @click="component.cancelDeleteFolder()"
                    class="action_btn"
                >
                    {{ $t("ViesValidator.cancel") }}
                </v-btn>
                <v-btn
                    outlined
                    @click="deleteFolder()"
                    :color="screen_data.deleteOption ? 'var(--v-primary-base)' : 'primary_blue'"
                    class="action_btn"
                    :disabled="!screen_data.deleteOption || loading_action"
                >
                    <span v-if="!loading_action">
                        {{ $t("ViesValidator.delete") }}
                    </span>
                    <div v-else>
                        <v-progress-circular
                            indeterminate
                            size="20"
                            width="2"
                            color="primary"
                        />
                    </div>
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent max-width="700"
            v-model="screen_data.popUpCreateFolder"
        >
            <v-card>
                <v-card-title class="text-center" >
                    <b>{{$t("ViesValidator.create_folder")}}</b>
                </v-card-title>
                <div 
                    :style="{
                        padding: is_mobile?'2vh 6vw':'2vh 2vw'
                    }"
                >
                    <v-text-field
                        v-model="screen_data.newFolderName"
                        :label="$t('ViesValidator.folder_name')"
                        outlined
                        dense
                        hide-details
                    >
                    </v-text-field>
                    <v-checkbox
                        v-model="screen_data.is_private"
                        :label="$t('ViesValidator.privacy_label')"
                    />
                </div>
                <v-card-actions class="action_btns">
                    <v-spacer></v-spacer>
                    <v-btn 
                        outlined
                        @click="component.cancelCreateFolder()"
                        class="action_btn"
                        >
                        {{$t("ViesValidator.cancel")}}
                    </v-btn>
                    <v-btn 
                        outlined
                        @click="createFolder()"
                        :color="!screen_data.newFolderName?'primary_blue':'var(--v-primary-base)'"
                        class="action_btn"
                        :disabled="!screen_data.newFolderName || loading_action"
                    >
                        <span v-if="!loading_action">
                            {{$t("ViesValidator.create")}}
                        </span>
                        <div v-else>
                            <v-progress-circular
                                indeterminate
                                size="20"
                                width="2"
                                color="primary"
                            />
                        </div>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent max-width="700"
            v-model="screen_data.popUpEditFolder"
            ref="edit_folder"
        >
            <v-card>
                <v-card-title class="text-center" >
                    <b>{{ $t("ViesValidator.edit_folder") }}</b>
                </v-card-title>
                <div 
                    :style="{
                        padding: is_mobile?'2vh 6vw':'2vh 2vw'
                    }"
                >
                    <v-text-field
                        v-model="screen_data.folder_data.name"
                        :label="$t('ViesValidator.folder_name')"
                        outlined
                        dense
                        hide-details
                    >
                    </v-text-field>
                    <v-checkbox
                        v-model="screen_data.folder_data.is_private"
                        :label="$t('ViesValidator.privacy_label')"
                    />

                </div>
                <v-card-actions class="action_btns">
                    <v-spacer></v-spacer>
                    <v-btn 
                        outlined
                        @click="component.cancelEditFolder()"
                        class="action_btn"
                        >
                        {{$t("ViesValidator.cancel")}}
                    </v-btn>
                    <v-btn 
                        outlined
                        @click="editFolder()"
                        :color="!component.changeDetector()?'primary_blue':'var(--v-primary-base)'"
                        class="action_btn"
                        :disabled="!component.changeDetector() || loading_action"
                    >
                        <span v-if="!loading_action">
                            {{ $t("ViesValidator.edit") }}
                        </span>
                        <div v-else>
                            <v-progress-circular
                                indeterminate
                                size="20"
                                width="2"
                                color="primary"
                            />
                        </div>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <div 
            v-if="is_mobile"
            class="slide-menu"
            :class="show_folder_menu_mobile? 'open': 'close'"
            ref="slide_menu_ref"
        >
            <div style="height: 8%;background-color: var(--v-primaryLighter-base);padding: 0px 15px; border-radius: 0 10px 0 0; display: flex; align-items: center;">
                <button style="color: var(--v-primaryDark-base); font-family: Roboto; font-weight: 500; font-size: 16px; letter-spacing: 0px;"
                    @click="moveToFolder(true)"
                >
                    {{ $t("ViesValidator.my_unit") }}
                </button>
                <div style="display: flex; margin-left: auto;">
                    <button
                        v-if="userHasPermissions()"
                        :style="{
                            padding: '5px',
                            backgroundColor: 'var(--v-neutral-base)',
                            marginRight: '5px',
                            borderRadius: '10px',
                            opacity: selected_folder && selected_folder!='Mi unidad' ? 1 : 0.4,
                        }"
                        @click="component.showPopUpEditFolder(screen_data.companyFolders, selected_folder)" :disabled="!selected_folder || selected_folder == 'Mi unidad'"
                    >
                        <v-icon color="var(--v-primary-base)" size="18">mdi-pencil</v-icon>
                    </button>
                    <button
                        v-if="userHasPermissions()"
                        :style="{
                            paddingTop: '5px',
                            paddingBottom: '0px',
                            paddingLeft: '7px',
                            paddingRight: '7px',
                            backgroundColor: 'var(--v-neutral-base)',
                            marginRight: '5px',
                            borderRadius: '10px',
                            opacity: selected_folder && selected_folder!='Mi unidad' ? 1 : 0.4,
                        }"
                        @click="component.showPopUpDeleteFolder()" :disabled="!selected_folder || selected_folder == 'Mi unidad'"
                    >
                        <AppIcon :src="require('@/assets/delete_purple.svg')" :size="29" style="height: 16.88px; width: 15px;" />
                    </button>
                    <button
                        v-if="userHasPermissions()"
                        style="border: 1px solid var(--v-primary-base); padding: 5px 9px; display: flex; align-items: center; border-radius: 10px;"
                        @click="component.showPopUpCreateFolder(selected_folder)"
                    >
                        <AppIcon :src="require('@/assets/add.svg')" :size="29" style="height: 10px; width: 10px;" />
                        <span style="padding-left: 5px; font-family: Roboto; font-weight: 500; font-size: 13px; letter-spacing: 0px;">{{ $t("ViesValidator.new") }}</span>
                    </button>
                </div>
            </div>
            <div width="100%" style="overflow-y:auto; background-color: #ffffff; height: 92%; border-bottom-right-radius: 10px;">
                <FolderSelectorComponent
                    v-if="screen_data && screen_data.companyFolders && screen_data.companyFolders.length"
                    :items="screen_data.companyFolders[0].children"
                    v-model="selected_folder"
                    :show_selected_route="false"
                    @input="moveToFolder()"
                    initial_selected_folder=""
                    ref="folder_selector_mobile_ref"
                />
            </div>
        </div>
    </div>
    
</template>
  
<script>
import AppBtn from "@/components/layout/AppBtn.vue";
import AppRow from "@/components/layout/AppRow.vue";
import AppCol from "@/components/layout/AppCol.vue";
import { document_components_factory } from "@/api/client";
import DataTableWithApi from '../components/DataTableWithApi.vue';
import MessagePopup from '@/components/MessagePopup.vue';
import AppConfirmModal from '@/components/layout/AppConfirmModal.vue';
import AppTextField from '@/components/layout/AppTextField.vue';
import { mapGetters, mapActions } from "vuex";
import { OTHER_DOCUMENT_TYPES } from '../store/constants.js';
import AppDatePicker from '../components/DatePicker.vue';
import { DeleteDocumentsCommand } from "@/modules/document/application/DeleteDocumentsCommand";
import { CleanSearchFilters } from "@/modules/document/application/CleanSearchFilters";
import { MountDocumentList } from "@/modules/document/application/MountDocumentList";
import { DownloadDocumentsCommand } from '@/modules/document/application/DownloadDocuments';
import { jobs } from '../api/jobs.js';
import JobProgress from '../components/JobProgress.vue';
import { SortTable } from "@/modules/document/application/SortTable";
import { UpdateOffset } from "@/modules/document/application/UpdateOffset";
import { UpdateLimit } from "@/modules/document/application/UpdateLimit";
import { RefreshtList } from "@/modules/document/application/RefreshList";
import { SearchDocuments } from "@/modules/document/application/SearchDocuments";
import { ModifyWorkflowCommand } from "@/modules/document/application/ModifyWorkflowCommand";
import { WorkflowTemplatesQuery } from "@/modules/document/application/WorkflowTemplatesQuery";
import AppSelect from '@/components/layout/AppSelect.vue';
import { VueOtherDocumentListScreenData } from "@/modules/document/infra/VueOtherDocumentListScreenData";
import { OtherDocListComponent } from "@/modules/document/application/OtherDocListComponent";
import { ApiOtherDocumentRepository } from "@/modules/document/infra/ApiOtherDocumentRepository";
import AppSearchBar from '@/components/layout/AppSearchBar.vue';
import { ApiWorkflowTemplateRepository } from "@/modules/document/infra/ApiWorkflowTemplateRepository";  
import { DOCS_FIELD_MAP_SHOW } from "@/modules/document/domain/Document";
import { OtherDocDetailComponent } from '../modules/document/application/OtherDocDetailComponent'
import FolderSelectorComponent from "@/components/FolderSelectorComponent";
import LanguageSwitcher from '@/components/LanguageSwitcher.vue'
import PopupCreateCompany from "@/components/PopupCreateCompany.vue";
import AddFilterDocuments from "@/components/AddFilterDocuments.vue";
import ItemFilterDocuments from "@/components/ItemFilterDocuments.vue";
import { isMobile } from "filestack-js";
import { forEach } from "mathjs";
import { excelFileChosen } from "@/modules/invoices/domain/Invoice";
import GenericWarningPopUp from "@/modules/shared/infra/GenericWarningPopUp.vue";
export default {
    name: "ViesValidator",
    components: {
        AppTextField,
        AppBtn,
        AppCol,
        AppRow,
        DataTableWithApi,
        MessagePopup,
        AppConfirmModal,
        AppDatePicker,
        JobProgress,
        AppSelect,
        AppSearchBar,
        FolderSelectorComponent,
        LanguageSwitcher,
        PopupCreateCompany,
        GenericWarningPopUp,
        AddFilterDocuments,
        ItemFilterDocuments
    },
    data() {
        const comp = document_components_factory.get_or_create_list_component()
        // const screen_data = new VueOtherDocumentListScreenData();
        return {
            screen_data: comp.screen_data,
            component: comp,
            selected_folder: "",
            selected_folder_parent: null,
            show_popup_create_company: false,
            show_folder_menu: false,
            selected_menu_option: "",
            show_folders: true,
            isHovering: false,
            show_folder_menu_mobile: false,
            document_info_activated: [],
            items_filter: [
                {id: 1, name: "Nombre", imgSrc: require('@/assets/article.svg'), widthImg: 17, heightImg: 17},
                {id: 2, name: "Tipo", imgSrc: require('@/assets/sticky_note_2.svg'), widthImg: 17, heightImg: 17},
                {id: 3, name: "Fecha desde", imgSrc: require('@/assets/today.svg'), widthImg: 17, heightImg: 19.12},
                {id: 4, name: "Fecha hasta", imgSrc: require('@/assets/event.svg'), widthImg: 17, heightImg: 19.12},
                {id: 5, name: "Pendiente de mi aprobación", imgSrc: require('@/assets/beenhere.svg'), widthImg: 15, heightImg: 19.43},
            ],
            is_activate_filter: false,
            name_in_filter: "",
            orders_in_filter: [
                {id: 1, name: "A - Z", value: "original_file_name", selected: false},
                {id: 2, name: "Z - A", value: "-original_file_name", selected: false},
            ],
            types_in_filter:[
                {id: 1, name: "Todos", value: "", selected: false},
                {id: 2, name: "Otros", value: "otros", selected: false},
            ],
            date_from_in_filter: null,
            date_to_in_filter: null,
            pending_approval_in_filter: [
                {id: 1, name: "Todos", value:"all", selected: false},
                {id: 2, name: "Sí", value: "yes", selected: false},
                {id: 3, name: "No", value: "no", selected: false},
            ],
            loading_action: false,
            loading_download_mobile: ""
        };
    },
    props: {
        companydb_id: {
            type: [Number, String],
            required: true,
            default: null
        }
    },
    watch: {
        selected_folder: {
            handler(newVal){
                if(newVal == undefined || newVal === null){
                    this.selected_folder = "Mi unidad"
                    this.screen_data.currentFolderRoute = "Mi unidad"
                }
            },
            immediate: true
        },
        companydb_id(newVal) {
            this.component.getCompanyFolders(newVal)
            this.refreshDocuments()
        },
        'screen_data.popUpDeleteFolder'(val) {
            if (val) {
                this.screen_data.deleteOption = ''; 
            }
        }
    },
    computed: {
        title() {
            return this.$t('ViesValidator.documents')
        },
        ...mapGetters([
            "is_mobile",
        ]),
        ...mapGetters({
            got_feature:'got_feature',
            userData: 'me/userData',
            permission: 'permissions/permission',
        }),
        filteredHeaders() {
            if (this.got_feature('feature_gestor_label_documentos')) {
                const hiddenValues = ['id', 'workflow_name', 'state']
                return this.screen_data.other_documents_headers.filter(h => !hiddenValues.includes(h.value))
            }
            return this.screen_data.other_documents_headers
        },
        data_table_height() {
            if (this.is_mobile) return undefined
            else return this.screen_data.tableHeight
        },
        isMobile() {
            return this.$vuetify.breakpoint.smAndDown;
        },
    },
    methods: {
        userHasPermissions(){
            if(!this.screen_data.user_permissions){
                return false
            }
            const { user_role, permission } = this.screen_data.user_permissions
            const allowed_roles = ['owner','admin','employee']

            return allowed_roles.includes(user_role) && permission == 'writer'
        },
        async updateFilter(params){
            this.component.updateFilters(params)
            await this.component.searchDocuments(this.companydb_id)
        },
        async removeAllFilt(p){
            this.component.celanAllFilters()
            await this.component.searchDocuments(this.companydb_id)
        },
        selectRow(item) {
            let ident = item.uuid? item.uuid : item.id;
            let file_ext_matches = item.original_file_name.match(/\.[^/.]+$/g)
            let file_extension = ""
            if (file_ext_matches) {
                file_extension = file_ext_matches[0].toLowerCase()
            }
            if ([".pdf",".jpg",".jpeg",".png", ".xls", ".ods", ".xlsx"].includes(file_extension)) {
                this.$router.push({ 'name': "other-doc-detail", 'params': { 'companydb_id': this.companydb_id, 'other_document_id': ident }})
            }
            else {
                let other_doc_detail_component = new OtherDocDetailComponent(new ApiOtherDocumentRepository, this.screen_data)
                other_doc_detail_component.downloadOriginalFile(ident, item['original_file_name'])
            }

        },
        async refreshDocuments(){
            if(this.isMobile){
                this.screen_data.loading_odocs = true
                await this.get_documents_mobile()
                this.screen_data.loading_odocs = false
            }else{
                try {
                    await this.component.searchDocuments(this.companydb_id)
                } catch (error) {
                    console.error('Error refresh:', error);
                }
            }
        },
        formatField(field) {
            return DOCS_FIELD_MAP_SHOW[field] || field;
        },
        map_document_date(inputDate) {
            const date = new Date(inputDate);
            const formattedDate = date.toLocaleDateString('en-GB');
            return formattedDate;
        },
        confirmDeleteDocument(res){
            this.screen_data.showDeletePupup = false;
            this.screen_data.resolvePopupPromise(res)
        },
        async deleteOtherDocument() {
            try {
                await this.component.deleteDocs(this.companydb_id)
            } catch(error) {
                console.error('Error delete other document:', error);
            }
        },
        async moveDocumentsToFolder() {
            try {
                await this.component.moveDocumentsToFolder(this.companydb_id)
                await this.refreshDocuments()
            } catch (error){
                console.error("Error move documents to folder:", error);
            }
        },
        async downloadDocuments(doc=null){
            try {
                if(!this.isMobile){
                    this.component.downloadDocs()
                }else{
                    this.loading_download_mobile = doc.id
                    await this.component.downloadDocsMobile(doc)
                    await this.component.jobDone(this.companydb_id);
                    this.loading_download_mobile = ""
                }
            } catch (error) {
                console.error('Error while download documents', error);
            }
        },
        async relaunchWorkflow() {
            try {
                await this.component.relaunchWorkflow()
                await this.refreshDocuments()
            } catch (error) {
                console.error('Error while relaunch workflow:', error);
            }
        },
        async changeWorkflow() {
            try {
                await this.component.changeWorkflow()
                await this.refreshDocuments()
            } catch (error) {
                console.error('Error while changing workflow:', error);
            }
        },
        async jobDone(){
            try {
                await this.component.jobDone(this.companydb_id);
            } catch (error) {
                console.error('Error while job done:', error);
            }
        },
        showSelectAll() {
            // let length_items = this.screen_data.other_documents.length;
            // let length_selected = this.screen_data.selectedItems.length;
            // if (length_items == length_selected && length_items != 0) {
            //     return true;
            // }
            return false;
        },
        changeSelectAllItems(){
            if(this.screen_data.selectAllItems) {
                this.screen_data.selectedItems = []
                for(let i in this.screen_data.other_documents){
                    this.screen_data.selectedItems.push(this.screen_data.other_documents[i])
                }
            }
        },
        async changeOffset(value) {
            this.screen_data.offset = this.screen_data.limit*(value-1);
            try {
                await this.component.searchDocuments(this.companydb_id)
            } catch (error) {
                console.error('Error while changing offset:', error);
            }
        },
        async changeLimit(value) {
            this.screen_data.limit = value;
            try {
                await this.component.searchDocuments(this.companydb_id)
            } catch (error) {
                console.error('Error while changing limit:', error);
            }
        },
        async sortTable(params) {
            this.screen_data.sortBy = "";
            if (params && params[0]) {
                this.screen_data.sortBy = params[0];
            }
            try {
                await this.component.sortTable(this.companydb_id, params)
            } catch (error) {
                console.error('Error while sort table:', error);
            }
        },
        async sortTableDesc(params) {
            if (params && params[0] && this.screen_data.sortBy) {
                try {
                    await this.component.sortTable(this.companydb_id, params)
                } catch (error) {
                    console.error('Error while sort table:', error);
                }
                this.screen_data.sortBy=''
            }
        },
        async acceptToMoveDocumentsToFolder() {
            await this.component.confirmMoveDocumentsToFolder(this.selected_folder)
        },
        async moveToFolder(isSelectedMiUnidad = false){
            if (isSelectedMiUnidad){
                this.selected_folder = null;
                this.screen_data.currentFolderRoute = "Mi unidad";
            }
            await this.component.moveToFolder(this.selected_folder)
            await this.refreshDocuments()
        },
        changeLanguage(text) {
            switch(text){
                case "Nómina":
                    return "payroll"
                case "Contrato":
                    return "contract"
                case "Modelos/Impuestos":
                    return "model_tax"
                case "Certificado":
                    return "certificate"
                case "Facturas":
                    return "bill"
                case "Otros":
                    return "other"

                case "Sin workflow":
                    return "no_workflow"
                
                case "Id":
                    return "id"
                case "Nombre del documento":
                    return "document_name"
                case "Tipo de documento":
                    return "document_type"
                case "Fecha de subida":
                    return "upload_data"
                case "Workflow":
                    return "workflow"
                case "Estado":
                    return "state"

                default:
                    return "edit"
            }
        },
        round_folder_paths(path){
            let maxLetters = 33
            if (this.is_mobile) maxLetters = 50
            const carpetas = path.split("/")
            let countLetters = 0;
            carpetas[0] = this.$t("ViesValidator.my_unit")

            for(let i = carpetas.length-1 ;i>=0;i--){
                countLetters += carpetas[i].length +1 //+1 por la barra
                if (countLetters > maxLetters) {
                    return "..."+carpetas.slice(i+1).join("/")
                }
            }
            return carpetas.join("/")
        },
        change_folder_option(option){
            if(option === 'show_folders'){
                this.show_folders = true;
            }else if(option === 'not_show_folders'){
                this.show_folders = false;
            }else if(option === 'create_folder'){
                this.screen_data.popUpCreateFolder = true;
            }
            this.show_folder_menu = false;
        },
        handlerClickOutside(event){
            // Evento para cerrar el menú de gestión de carpetas (manageFolder) al hacer clic fuera de él. Solo se aplica en pantallas grandes (PC).
            // console.log("hola", this.show_folder_menu, Boolean(this.$refs.dropdown), !this.$refs.dropdown.contains(event.target))
            if (
                this.show_folder_menu &&
                this.$refs.dropdown &&
                !this.$refs.dropdown.contains(event.target)
            ){
                this.show_folder_menu = false;
            }
            // Evento para cerrar el menú de gestión de carpetas (manageFolder) al hacer clic fuera de él. Solo se aplica en pantallas pequeñas (móviles).
            // console.log("hola", this.show_folder_menu_mobile, Boolean(this.$refs.slide_menu_ref), !this.$refs.dropdown.contains(event.target), !this.$refs.slide_menu_ref.contains(event.target), !this.screen_data.popUpDeleteFolder, !this.screen_data.popUpEditFolder)
            if(
                this.$refs.dropdown &&
                !this.$refs.dropdown.contains(event.target) &&
                this.show_folder_menu_mobile &&
                this.$refs.slide_menu_ref && 
                !this.$refs.slide_menu_ref.contains(event.target) &&
                !this.screen_data.popUpDeleteFolder &&
                !this.screen_data.popUpCreateFolder &&
                !this.screen_data.popUpEditFolder

            ){
                this.show_folder_menu_mobile = false
            }
        },
        handleManageFolder(){
            if (this.is_mobile) {
                this.show_folder_menu_mobile = true;
            } else {
                this.show_folder_menu = !this.show_folder_menu;
            }
        },
        getReadableState(state) {
            let result = state
            switch(state){
                case "done":
                    return "Completado"
                case "error":
                    return "Error"
                case "waiting_approval":
                    return "Esperando"
                case "rejected":
                    return "Rechazada"
            }
            return state
        },
        handleShowInfo(doc_uuid){
            const idx = this.document_info_activated.indexOf(doc_uuid)
            if (idx === -1){
                this.document_info_activated.push(doc_uuid)
            }else{
                this.document_info_activated.splice(idx, 1)
            }
        },
        isInfoActive(doc_uuid){
            return this.document_info_activated.includes(doc_uuid)
        },
        getNameFolderSelected(route){
            const parts_route_folder = route.split("/")
            return parts_route_folder[parts_route_folder.length-1]
        },
        async get_documents_mobile(){
            let need_approval = ""
            this.pending_approval_in_filter.forEach((pending_approval) => {
                if(pending_approval.selected){
                    need_approval = pending_approval.value
                    return;
                }
            })
            let type = ""
            this.types_in_filter.forEach((t) => {
                if(t.selected){
                    type = t.value
                    return;
                }
            })
            let order = ""
            this.orders_in_filter.forEach((o) => {
                if(o.selected){
                    order = o.value
                    return;
                }
            })
            await this.component.get_documents_mobile(this.companydb_id, need_approval, this.name_in_filter, type, this.date_from_in_filter, this.date_to_in_filter, order)
        },
        async handlerActivateFilter(){
            if(this.is_activate_filter){
                this.screen_data.loading_odocs = true
                await this.get_documents_mobile()
            }
            this.is_activate_filter = !this.is_activate_filter
            this.screen_data.loading_odocs = false

        },
        changeNameInFilter(payload){
            this.name_in_filter = payload.name
            this.orders_in_filter = payload.orders
        },
        changeTypesInFilter(value){
            this.types_in_filter = value
        },
        async deleteFolder(){
            this.loading_action = true
            await this.component.deleteFolder(this.selected_folder, this.companydb_id, this.screen_data.deleteOption === 'delete_folder_delete_content')
            this.selected_folder = "Mi unidad"
            this.screen_data.currentFolderRoute = "Mi unidad"
            this.loading_action = false
        },
        async createFolder(){
            this.loading_action = true
            let result = await this.component.createFolder(this.companydb_id, this.selected_folder)
            if(result && result.output && result.output.uuid){
                if(this.isMobile){
                    this.$refs.folder_selector_mobile_ref.setOpenAndActive(result.output.uuid)
                }else{
                    this.$refs.folder_selector_ref.setOpenAndActive(result.output.uuid)
                }
            }
            this.loading_action = false
        },
        async editFolder(){
            this.loading_action = true
            await this.component.editFolder(this.companydb_id, this.selected_folder, this.screen_data.folder_data.name, this.screen_data.folder_data.is_private)
            this.loading_action = false
        }, 
        changePendingApprovalInFilter(value){
            this.pending_approval_in_filter = itemValue
        },
        changeDateFrom(newVal){
            this.date_from_in_filter = newVal
        },
        changeDateTo(newVal){
            this.date_to_in_filter = newVal
        },
        countFilters(){
            let count = 0
            if(this.name_in_filter) count++
            this.orders_in_filter.forEach((order) => {
                if(order.selected) count++
            })
            this.types_in_filter.forEach((type)=> {
                if(type.selected) count++
            })
            if(this.date_from_in_filter) count++
            if(this.date_to_in_filter) count++
            this.pending_approval_in_filter.forEach((pending_approval) => {
                if(pending_approval.selected) count++
            })
            return count
        },
        async clear_filters(){
            this.screen_data.loading_odocs = true
            this.pending_approval_in_filter.forEach((pending_approval) => {
                pending_approval.selected = false
            })
            this.name_in_filter = ""
            this.types_in_filter.forEach((type) => {
                type.selected = false
            })
            this.date_from_in_filter = ""
            this.date_to_in_filter = ""
            this.orders_in_filter.forEach((order) => {
                order.selected = false
            })
            await this.component.get_documents_mobile(this.companydb_id, "", "", "", "", "", "")
            this.screen_data.loading_odocs = false
        },
        capitalizeText(text){
            if(!text) return ''
            const letter = text[0].toUpperCase()
            const rest = text.slice(1)
            return letter + rest
        },
        abbreviate(text){
            let words = text.split(" ")
            let count = 0
            for(let i=0;i<words.length;i++){
                count += words[i].length+1
                if(count>11){
                    return words.slice(0,i).join(" ")
                }
            }
            return text
        },
        fortmatedDate(dateString){
            const date = new Date(dateString)
            const day = String(date.getDate()).padStart(2, '0')
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const year = String(date.getFullYear())
            const hour = String(date.getHours()).padStart(2, '0')
            const minute = String(date.getMinutes()).padStart(2, '0')
            return day+"/"+month+"/"+year+" "+hour+":"+minute
        },
        copyIdToClipboard(id){
            // Copy plain text without JSON formatting
            if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
                navigator.clipboard.writeText(id)
                    .then(() => console.log("ID copied successfully!"))
                    .catch(err => {
                        console.error("Failed to copy ID:", err);
                        alert("Failed to copy. Please try again.");
                    });
            } else {
                // Fallback for older browsers
                const textArea = document.createElement("textarea");
                textArea.value = id;
                textArea.style.position = "fixed";
                textArea.style.opacity = "0";
                document.body.appendChild(textArea);
                textArea.select();

                try {
                    const successful = document.execCommand("copy");
                    console.log("ID copied using fallback method:", successful);
                } catch (err) {
                    console.error("Fallback copy failed:", err);
                    alert("Clipboard copy not supported in your browser.");
                }

                document.body.removeChild(textArea);
            }
        }
    },
    async mounted() {
        if(this.isMobile) this.show_folders = false
        this.selected_folder = "Mi unidad"
        this.screen_data.currentFolderRoute = "Mi unidad"

        this.component = new OtherDocListComponent(new ApiOtherDocumentRepository(), this.screen_data, new ApiWorkflowTemplateRepository());
        if(this.isMobile){
            await this.component.mountMobile(this.companydb_id, this.types_in_filter)
        }else{
            await this.component.mount(this.companydb_id)
        }
        document.addEventListener("click", this.handlerClickOutside)
    },

    beforeDestroy() {
        document.removeEventListener('click', this.handlerClickOutside);
    },
};
</script>

<style scoped>

    .upload_docs {
        font-weight: 500;
        font-size: 13px;
        line-height: 14px;
        border-radius: 20px;
        padding: 14px !important;
        gap: 8px;
        text-transform: capitalize;
    }
  
    ::v-deep .v-data-table-header > tr > th > span{
      color: var(--v-primary-base);
      font-size: 0.875rem;
    }
    ::v-deep .v-data-table-header > tr > th{
        background-color: var(--v-primaryLight-base) !important;
    }
    ::v-deep tbody > tr {
            color: #56565B;
    }
    ::v-deep tbody tr:nth-of-type(even) {
        background-color: rgba(245, 245, 245, 0.47);
    }
    ::v-deep .v-data-table__wrapper > table > tbody > tr > td {
        border-bottom: none !important;
    }

    ::v-deep .v-data-table__wrapper {
        border-radius: 8px;
    }

    .actions {
        padding-right: 1.38rem;
    }
    .action__btn {
        border: 1px solid var(--v-primary-base) ;
        border-radius: 18px;
        color: var(--v-primary-base);
        background-color: #FFFFFF !important;
    }
    .action__btn.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
        background-color: #FFFFFF !important;
    }
    .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover {
        color: var(--v-primary-base) !important;
        background: rgb(102, 51, 153, 0.1) !important;
    }

    .filter {
		padding-left: 10px;
		padding-right: 10px;
	}
	.search-btn {
		text-align: center;
	}
    .title-color {
		color:var(--v-primary-base);
	}

    .progress-circular {
        text-align:center;
        width: 100px;
    }

    .card__headline {
        background-color: color-mix(in srgb, var(--v-primaryLight-base) 20%, white);
        height: 70px;
    }
    
    .card__headline span {
        font-size: 20px;
        font-weight: 600;
        font-family: "Roboto";
        line-height: 24px;
        text-transform: capitalize;
        color: var(--v-primary_blue-base);
    }

    .action_btns {
        display: flex !important;
        justify-content: space-between !important;
        padding: 0 24px 20px;
        
    }
    .action_btn {
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        border-radius: 20px;
        padding: 18px !important;
        gap: 8px;
        text-transform: capitalize;
    }
    .ellipsis-text {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .popup_container_show_folders {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1000;
    }

    .popup_show_folders {
        background: white;
        padding: 15px;
        width: 600px;
      
        border-radius: 10px;
        box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
        text-align: center;
        color: #66369B !important;
        z-index: 1001;
    }
    .close-btn {
        background: none;
        border: none;
        font-size: 20px;
        color: #66369B;
        cursor: pointer;
    }
    .dropdown-item:hover {
        background-color: #F3F3F3;
    }

    .tooltip-text{
        visibility: hidden;
        position: absolute;
    }

    .tooltip-wrapper:hover .tooltip-text{
        visibility: visible;
        position: absolute;
        top: 100%;
        left: -50%;
        padding: 7px 10px;
        border-radius: 4px;
        z-index: 999;
        background-color: #565656;
        color: var(--v-neutral-base);
        font-weight: 500;
        font-size: 14px;
    }

    .layout-principal{
        position: relative;
        overflow: hidden;
    }

    .slide-menu {
        position: fixed;
        top: 75px;
        left: 0;
        height: 100%;
        width: 80%;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
        background-color: #ffffff;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
        z-index: 1;
    }

    .slide-menu.open {
        transform: translateX(0)
    }
    .slide-menu.close {
        transform: translateX(-100%)
    }

    .animation-information-enter-active,
    .animation-information-leave-active{
        transition: all 0.2s ease
    }

    .animation-information-enter-from,
    .animation-information-leave-to{
        opacity: 0;
        transform: translateY(-8px) !important;
    }

    .animation-information-enter-to,
    .animation-information-leave-from {
        opacity: 1;
        transform: translateY(0)
    }

</style>

<!-- Mobile GenericDocumentList -->
<style>
.generic-document-list {
  overflow-y: hidden !important;

  padding: 0 !important;

  .v-card__title {
    padding: 5px !important;

    .col{
      padding: 0 !important;
    }

    .flex-grow-1.col {
      display: flex;
      flex-direction: row;
      justify-content: center;
    }
  }

  thead > tr > th{
      border: 1px solid #ccc;
      border-radius: 0 !important;
  }

  .container {
      padding: 0 !important;
  }

  .app-col--no-input-fields-above{
      padding: 0 !important;
  }

  .v-data-table__wrapper {
    min-height: calc(90vh - 220px); 
    max-height: calc(100vh - 220px);
    overflow-y: auto;
    margin-bottom: 2px !important;
    border-radius: 0 !important;

    table {
      tbody > tr {
        td:first-child {
          background-color: #5C3D8F !important;

          .theme--light.v-icon{
            color: white !important;
          }
        }
        td {
          border: 1px solid gray;
        }
      }
    }
  }

  .v-data-footer{
    margin: 0 !important;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: center;
    justify-content: center;
    align-items: center;
    min-height: 45px;

    .v-data-footer__select{
      margin: 0 !important;
      display: none !important;
    }
  }

  .v-card__text{
    padding: 0 !important;
  }

  .v-data-table-header-mobile__wrapper{
    width: fit-content;
    min-height: 8vh
  }

  .v-text-field{
    padding-top: 0 !important; 
    margin-top: 0 !important;
  }

  .v-input{
    margin-top:16px !important;
  }
  
  .v-data-table {
    padding: 0 !important;
  }

  .card-header--mobile {
    padding-left: 1.38rem !important;
  }

  .card-title--mobile {

    .card-title--mobile_row {

        .left-section {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            align-content: center;
            justify-content: space-around;
            align-items: center;
            padding-left: 1.38rem !important;
        }
    }
  
  }

  .col-12 {
    padding: 0 !important;
  }
}
</style>